var config = [
  "bold",
  "italic",
  "strike",
  "underline",
  {
    formatName: "header",
    formatValues: [1, 2, 3, false],
  },
];
export default config;
